import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AdminNavbar from "../Layout/AdminNavbar";
import API_BASE_URL from "../config";

const AllocationPage = () => {

    const navigate = useNavigate();
    const [employeeAvailableHours, setEmployeeAvailableHours] = useState(0);
    const [activeTab, setActiveTab] = useState("utilization");
    const [savedAllocations, setSavedAllocations] = useState([]);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);



    const [data, setData] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [projects, setProjects] = useState([]);


    const getCurrentMonth = () => {
        return new Date().toISOString().slice(0, 7); // YYYY-MM
    };



    const [filters, setFilters] = useState({
        employeeId: "",
        projectId: "",
        month: getCurrentMonth()
    });



    // ADD at top with other states
    const [showAllocateModal, setShowAllocateModal] = useState(false);

    const [allocateForm, setAllocateForm] = useState({
        employeeId: "",
        projectId: "",
        percent: "",
        startDate: "",
        endDate: "",
        monthlyHours: ""
    });

    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: "asc"
    });

    const [savedSortConfig, setSavedSortConfig] = useState({
        key: null,
        direction: "asc"
    });

    const [billingSortConfig, setBillingSortConfig] = useState({
        key: null,
        direction: "asc"
    });


    const [expandedProjects, setExpandedProjects] = useState({});
    const [billingData, setBillingData] = useState([]);
    const [billingLoading, setBillingLoading] = useState(false);

    const [allProjects, setAllProjects] = useState([]);
    const [showExportMenu, setShowExportMenu] = useState(false);
    const warningShownRef = React.useRef(false);






    const getMonthFromDate = (date) => {
        if (!date) return "";

        const d = new Date(date);
        return d.toISOString().slice(0, 7); // YYYY-MM
    };


    const getLastDayOfMonth = (date) => {
        const d = new Date(date);

        const lastDay = new Date(
            d.getFullYear(),
            d.getMonth() + 1,
            0
        );

        const year = lastDay.getFullYear();
        const month = String(lastDay.getMonth() + 1).padStart(2, "0");
        const day = String(lastDay.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };


    useEffect(() => {
        fetchSavedAllocations();
    }, []);


    useEffect(() => {
        const handleClickOutside = () => {
            setShowExportMenu(false);
        };

        if (showExportMenu) {
            document.addEventListener("click", handleClickOutside);
        }

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [showExportMenu]);



    useEffect(() => {
        if (activeTab === "saved") {
            fetchSavedAllocations();
        }
    }, [activeTab]);

    const fetchSavedAllocations = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await fetch(`${API_BASE_URL}/api/allocation/saved-view`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (!res.ok) throw new Error();

            const result = await res.json();
            setSavedAllocations(result);

        } catch {
            toast.error("Failed to load saved allocations");
        }
    };





    const fetchProjectsByEmployee = async (employeeId) => {
        try {
            const token = localStorage.getItem("token");

            const res = await fetch(
                `${API_BASE_URL}/api/manageteam/employee/${employeeId}/projects`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (!res.ok) throw new Error();

            const result = await res.json();
            setProjects(result);

        } catch {
            toast.error("Failed to load employee projects");
        }
    };


    useEffect(() => {
        // Bootstrap CSS
        const bootstrapLink = document.createElement("link");
        bootstrapLink.rel = "stylesheet";
        bootstrapLink.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
        bootstrapLink.id = "bootstrap-css";
        document.head.appendChild(bootstrapLink);

        // Bootstrap Icons
        const iconsLink = document.createElement("link");
        iconsLink.rel = "stylesheet";
        iconsLink.href = "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
        iconsLink.id = "bootstrap-icons";
        document.head.appendChild(iconsLink);

        //  Bootstrap JS (THIS WAS MISSING)
        const script = document.createElement("script");
        script.src = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js";
        script.id = "bootstrap-js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.getElementById("bootstrap-css")?.remove();
            document.getElementById("bootstrap-icons")?.remove();
            document.getElementById("bootstrap-js")?.remove();
        };
    }, []);





    const fetchAvailableHoursByDate = async (employeeId, date) => {
        try {
            const token = localStorage.getItem("token");

            const month = getMonthFromDate(date);

            const params = new URLSearchParams();
            params.append("employeeId", employeeId);
            params.append("month", month);

            const res = await fetch(`${API_BASE_URL}/api/allocation?${params}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const result = await res.json();

            if (result.length > 0) {
                setEmployeeAvailableHours(result[0].availableHours);
            }

        } catch {
            toast.error("Failed to fetch available hours");
        }
    };

    const getRemainingHours = (employeeId, startDate) => {
        if (!employeeId || !startDate) return employeeAvailableHours;

        const month = getMonthFromDate(startDate);

        const usedHours = savedAllocations
            .filter(a =>
                a.employeeId === Number(employeeId) &&
                a.startDate.startsWith(month)
            )
            .reduce((sum, a) => sum + Number(a.monthlyHours || 0), 0);

        return Math.max(employeeAvailableHours - usedHours, 0);
    };



    const handleAllocateChange = (e) => {
        const { name, value } = e.target;

        setAllocateForm(prev => {
            let updated = { ...prev, [name]: value };

            if (name === "employeeId" && value) {
                fetchProjectsByEmployee(value);
            }

            if (name === "employeeId") {
                updated.projectId = "";
            }


            if (name === "startDate") {
                updated.endDate = getLastDayOfMonth(value);
            }

            if (updated.employeeId && updated.startDate) {
                fetchAvailableHoursByDate(updated.employeeId, updated.startDate);
            }

            const percent = Number(updated.percent);

            const remainingPercent = getRemainingPercent(
                updated.employeeId,
                updated.startDate
            );

            if (percent > remainingPercent) {
                if (!warningShownRef.current) {
                    toast.warning(`Only ${remainingPercent}% allocation left`);
                    warningShownRef.current = true;
                }
                updated.percent = remainingPercent;
            } else {
                warningShownRef.current = false;
            }


            const remainingHours = getRemainingHours(
                updated.employeeId,
                updated.startDate
            );

            updated.monthlyHours =
                ((updated.percent / 100) * employeeAvailableHours).toFixed(1);



            return updated;
        });
    };






    useEffect(() => {
        const token = localStorage.getItem("token");
        const roles = JSON.parse(localStorage.getItem("roles") || "[]");

        if (!token || !roles.includes("ROLE_ADMIN")) {
            toast.error("Unauthorized");
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        const fetchEmployees = async () => {
            const token = localStorage.getItem("token");
            const res = await fetch(`${API_BASE_URL}/api/employees/active`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setEmployees(await res.json());
        };
        fetchEmployees();
    }, []);

    useEffect(() => {
        const fetchAllocation = async () => {
            setLoading(true);

            const token = localStorage.getItem("token");
            const params = new URLSearchParams();

            if (filters.employeeId) params.append("employeeId", filters.employeeId);
            if (filters.month) params.append("month", filters.month);

            const res = await fetch(`${API_BASE_URL}/api/allocation?${params}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setData(await res.json());
            setLoading(false);
        };

        fetchAllocation();
    }, [filters]);

    const handleFilterChange = (e) =>
        setFilters(prev => ({ ...prev, [e.target.name]: e.target.value }));

    // const resetFilters = () => setFilters({ employeeId: "", month: "" });

    const filteredData = data.filter(d =>
        d.employeeName.toLowerCase().includes(search.toLowerCase())
    );

    const filteredSavedAllocations = savedAllocations.filter(a => {

        // Search by employee name
        const matchesSearch =
            a.employeeName?.toLowerCase().includes(search.toLowerCase());

        // Employee filter
        const matchesEmployee =
            !filters.employeeId ||
            a.employeeId === Number(filters.employeeId);

        // Month filter
        const matchesMonth =
            !filters.month ||
            a.startDate?.startsWith(filters.month);

        //project filter
        const matchesProject =
            !filters.projectId ||
            a.projectId === Number(filters.projectId);


        return matchesSearch && matchesEmployee && matchesMonth && matchesProject;

    });


    const avgUtil =
        data.length > 0
            ? (data.reduce((a, b) => a + b.overallUtilization, 0) / data.length).toFixed(1)
            : 0;

    const overUtilized = data.filter(d => d.overallUtilization > 100).length;



    const renderProgress = (val) => {

        let color = "bg-success";

        if (val > 100) {
            color = "bg-primary"; // over-utilized
        } else if (val < 40) {
            color = "bg-danger"; // very low
        } else if (val >= 40 && val < 60) {
            color = "bg-warning"; // moderate
        } else if (val >= 60 && val <= 100) {
            color = "bg-success"; // healthy
        }

        return (
            <div className="progress mt-1" style={{ height: "6px" }}>
                <div
                    className={`progress-bar ${color}`}
                    style={{ width: `${Math.min(val, 100)}%` }}
                />
            </div>
        );
    };





    const saveAllocation = async () => {
        try {
            const token = localStorage.getItem("token");

            if (!allocateForm.employeeId ||
                !allocateForm.projectId ||
                !allocateForm.percent ||
                !allocateForm.startDate ||
                !allocateForm.endDate ||
                !allocateForm.monthlyHours) {

                toast.error("Please fill all fields");
                return;
            }

            //  NEW — prevent 0 or negative percent
            if (Number(allocateForm.percent) <= 0) {
                toast.error("Allocation % must be greater than 0");
                return;
            }

            //  NEW — prevent 0 monthly hours
            if (Number(allocateForm.monthlyHours) <= 0) {
                toast.error("Monthly allocated hours must be greater than 0");
                return;
            }

            //  Duplicate check
            const month = allocateForm.startDate.slice(0, 7);

            const duplicate = savedAllocations.some(a =>
                a.employeeId === Number(allocateForm.employeeId) &&
                a.projectId === Number(allocateForm.projectId) &&
                a.startDate.startsWith(month)
            );

            if (duplicate) {
                toast.error("Allocation already exists for this month");
                return;
            }


            const res = await fetch(`${API_BASE_URL}/api/allocation/save`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    employeeId: Number(allocateForm.employeeId),
                    projectId: Number(allocateForm.projectId),
                    percent: Number(allocateForm.percent),
                    monthlyHours: Number(allocateForm.monthlyHours),
                    startDate: allocateForm.startDate,
                    endDate: allocateForm.endDate
                })
            });

            if (!res.ok) throw new Error();

            toast.success("Allocation saved successfully ");

            fetchSavedAllocations();
            setShowAllocateModal(false);

            // refresh allocations
            setSavedAllocations(prev => [
                ...prev,
                {
                    employeeId: Number(allocateForm.employeeId),
                    projectId: Number(allocateForm.projectId)
                }
            ]);

            setAllocateForm({
                employeeId: "",
                projectId: "",
                percent: "",
                startDate: "",
                endDate: "",
                monthlyHours: ""
            });

        } catch {
            toast.error("Failed to save allocation");
        }
    };


    const resetAllocateForm = () => {
        setAllocateForm({
            employeeId: "",
            projectId: "",
            percent: "",
            startDate: "",
            endDate: "",
            monthlyHours: ""
        });

        setEmployeeAvailableHours(0);
        setProjects([]);
    };


    const confirmDeleteAllocation = async () => {
        if (!deleteTarget) return;

        try {
            const token = localStorage.getItem("token");

            const res = await fetch(
                `${API_BASE_URL}/api/allocation/${deleteTarget.id}`,
                {
                    method: "DELETE",
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (!res.ok) throw new Error();

            toast.success("Allocation deleted");

            setShowDeleteModal(false);
            setDeleteTarget(null);

            fetchSavedAllocations();

        } catch {
            toast.error("Failed to delete allocation");
        }
    };


    useEffect(() => {
        setFilters({
            employeeId: "",
            projectId: "",
            month: getCurrentMonth()
        });
        setSearch("");
    }, [activeTab]);



    const requestBillingSort = (key) => {
        let direction = "asc";

        if (billingSortConfig.key === key && billingSortConfig.direction === "asc") {
            direction = "desc";
        }

        setBillingSortConfig({ key, direction });
    };


    const sortBillingData = (list) => {
        if (!billingSortConfig.key) return list;

        return [...list].sort((a, b) => {

            const getValue = (row) => {
                if (billingSortConfig.key === "projectName") return row.projectName;
                if (billingSortConfig.key === "billing") return row.totalBillingHours;
                if (billingSortConfig.key === "allocated") return row.totalAllocatedHours;
                if (billingSortConfig.key === "utilization") return row.avgUtilization;
            };

            const aVal = getValue(a);
            const bVal = getValue(b);

            if (typeof aVal === "number") {
                return billingSortConfig.direction === "asc"
                    ? aVal - bVal
                    : bVal - aVal;
            }

            return billingSortConfig.direction === "asc"
                ? String(aVal).localeCompare(String(bVal))
                : String(bVal).localeCompare(String(aVal));
        });
    };



    const sortData = (list, config) => {
        if (!config.key) return list;

        return [...list].sort((a, b) => {

            const getValue = (row) => {
                if (config.key === "allocatedHours") {
                    return getAllocatedHours(row.employeeId, row.availableHours);
                }

                if (config.key === "remainingHours") {
                    return getRemainingUtilizationHours(row.employeeId, row.availableHours);
                }

                return row[config.key];
            };

            const aVal = getValue(a);
            const bVal = getValue(b);

            if (aVal == null) return 1;
            if (bVal == null) return -1;

            if (typeof aVal === "number") {
                return config.direction === "asc"
                    ? aVal - bVal
                    : bVal - aVal;
            }

            return config.direction === "asc"
                ? String(aVal).localeCompare(String(bVal))
                : String(bVal).localeCompare(String(aVal));
        });
    };



    const requestSort = (key) => {
        let direction = "asc";

        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }

        setSortConfig({ key, direction });
    };

    const requestSavedSort = (key) => {
        let direction = "asc";

        if (savedSortConfig.key === key && savedSortConfig.direction === "asc") {
            direction = "desc";
        }

        setSavedSortConfig({ key, direction });
    };


    const getAllocatedHours = (employeeId, availableHours) => {

        const month = filters.month;

        const list = month
            ? savedAllocations.filter(a =>
                a.employeeId === Number(employeeId) &&
                a.startDate.startsWith(month)
            )
            : savedAllocations.filter(a =>
                a.employeeId === Number(employeeId)
            );

        return list.reduce((sum, a) => sum + Number(a.monthlyHours || 0), 0);
    };


    const getRemainingUtilizationHours = (employeeId, availableHours) => {
        const allocated = getAllocatedHours(employeeId, availableHours);
        return Math.max(Number(availableHours) - allocated, 0);
    };


    const toggleProject = (projectName) => {
        setExpandedProjects(prev => ({
            ...prev,
            [projectName]: !prev[projectName]
        }));
    };



    const fetchBillingSummary = async () => {
        try {
            setBillingLoading(true);

            const token = localStorage.getItem("token");

            const params = new URLSearchParams();

            if (filters.month) {
                params.append("month", filters.month);
            }

            const res = await fetch(
                `${API_BASE_URL}/api/allocation/billing-summary?${params}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (!res.ok) throw new Error();

            const result = await res.json();
            setBillingData(result);

        } catch {
            toast.error("Failed to load billing summary");
        } finally {
            setBillingLoading(false);
        }
    };


    const handleExport = async (format) => {
        try {
            let endpoint = "";

            if (activeTab === "utilization") {
                endpoint = "/api/reports/allocation/utilization";
            }

            if (activeTab === "saved") {
                endpoint = "/api/reports/allocation/saved";
            }

            if (activeTab === "billing") {
                endpoint = "/api/reports/allocation/billing";
            }

            const params = new URLSearchParams();

            if (filters.employeeId) params.append("employeeId", filters.employeeId);
            if (filters.projectId) params.append("projectId", filters.projectId);
            if (filters.month) params.append("month", filters.month);

            params.append("format", format);

            const token = localStorage.getItem("token");

            const res = await fetch(
                `${API_BASE_URL}${endpoint}?${params.toString()}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (!res.ok) throw new Error("Export failed");

            const blob = await res.blob();

            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = `allocation-report.${format === "pdf" ? "pdf" : "xlsx"}`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);

        } catch (err) {
            toast.error("Export failed");
            console.error(err);
        }
    };



    useEffect(() => {
        if (activeTab === "billing") {
            fetchBillingSummary();
        }
    }, [activeTab, filters.month]);


    const filteredBillingData = billingData.filter(project => {

        const matchesProject =
            !filters.projectId ||
            project.projectName ===
            allProjects.find(p => p.id === Number(filters.projectId))?.name;

        if (!matchesProject) return false;

        return true;

    }).map(project => {

        const filteredEmployees = project.employees.filter(emp => {

            const matchesSearch =
                emp.employeeName?.toLowerCase().includes(search.toLowerCase());

            const matchesEmployee =
                !filters.employeeId ||
                employees.find(e =>
                    e.id === Number(filters.employeeId) &&
                    `${e.firstName} ${e.lastName}` === emp.employeeName
                );

            return matchesSearch && matchesEmployee;
        });

        return { ...project, employees: filteredEmployees };

    }).filter(project => project.employees.length > 0);



    useEffect(() => {
        const uniqueProjects = Array.from(
            new Map(
                savedAllocations.map(p => [p.projectId, {
                    id: p.projectId,
                    name: p.projectName
                }])
            ).values()
        );

        setAllProjects(uniqueProjects);
    }, [savedAllocations]);



    const getRemainingPercent = (employeeId, startDate) => {

        if (!employeeId || !startDate) return 100;

        const month = getMonthFromDate(startDate);

        const usedPercent = savedAllocations
            .filter(a =>
                a.employeeId === Number(employeeId) &&
                a.startDate.startsWith(month)
            )
            .reduce((sum, a) => sum + Number(a.allocationPercent || 0), 0);

        return Math.max(100 - usedPercent, 0);
    };


    const getNextMonthDates = (dateStr) => {

        if (!dateStr) return { startDate: "", endDate: "" };

        const [year, month] = dateStr.split("-").map(Number);

        const nextMonth = month === 12 ? 1 : month + 1;
        const nextYear = month === 12 ? year + 1 : year;

        // Start of next month
        const startDate = `${nextYear}-${String(nextMonth).padStart(2, "0")}-01`;

        // End of next month
        const end = new Date(nextYear, nextMonth, 0);
        const endDate = `${nextYear}-${String(nextMonth).padStart(2, "0")}-${String(end.getDate()).padStart(2, "0")}`;

        return { startDate, endDate };
    };


    const validateAllocationForm = (form) => {

        if (!form.employeeId || !form.startDate) return;

        const remainingPercent = getRemainingPercent(
            form.employeeId,
            form.startDate
        );

        if (Number(form.percent) > remainingPercent) {
            toast.warning(`Only ${remainingPercent}% allocation left`);

            setAllocateForm(prev => ({
                ...prev,
                percent: remainingPercent,
                monthlyHours: ((remainingPercent / 100) * employeeAvailableHours).toFixed(1)
            }));
        }
    };



    const handleCopyAllocation = (allocation) => {

        const { startDate, endDate } = getNextMonthDates(allocation.startDate);

        const newForm = {
            employeeId: allocation.employeeId,
            projectId: allocation.projectId,
            percent: allocation.allocationPercent,
            startDate,
            endDate,
            monthlyHours: allocation.monthlyHours
        };

        setAllocateForm(newForm);

        fetchProjectsByEmployee(allocation.employeeId);
        fetchAvailableHoursByDate(allocation.employeeId, startDate);

        // trigger validation AFTER state set
        setTimeout(() => validateAllocationForm(newForm), 100);

        setShowAllocateModal(true);
    };






    return (
        <div className="d-flex flex-column" style={{ height: "100vh", overflow: "hidden" }}>

            {/* Sticky Navbar */}
            <div style={{ position: "sticky", top: 0, zIndex: 1000 }}>
                <AdminNavbar />
            </div>

            {/* Scrollable Content */}
            <div
                className="container-fluid bg-light flex-grow-1 px-2 py-3"
                style={{ overflowY: "hidden" }}
            >

                {/* KPI Cards */}
                <div className="d-flex gap-3 mb-3 flex-wrap">
                    <div className="card shadow-sm border-0 px-3 py-2 bg-secondary text-white" style={{ minWidth: "180px" }}>
                        <small>Total Employees</small>
                        <div>{data.length}</div>
                    </div>

                    <div className="card shadow-sm border-0 px-3 py-2 bg-success text-white" style={{ minWidth: "180px" }}>
                        <small>Avg Utilization</small>
                        <div>{avgUtil}%</div>
                    </div>

                    <div className="card shadow-sm border-0 px-3 py-2 bg-primary text-white" style={{ minWidth: "180px" }}>
                        <small>Over Utilized</small>
                        <div>{overUtilized}</div>
                    </div>
                </div>

                <div className="card shadow-lg border-0" >

                    <div className="card-header bg-white">

                        <div className="d-flex justify-content-between align-items-center" >

                            <div className="btn-group" >
                                <button
                                    className={`btn ${activeTab === "utilization" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => setActiveTab("utilization")}
                                >
                                    Utilization
                                </button>

                                <button
                                    className={`btn ${activeTab === "saved" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => setActiveTab("saved")}
                                >
                                    Allocations
                                </button>

                                <button
                                    className={`btn ${activeTab === "billing" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => setActiveTab("billing")}
                                >
                                    Billing
                                </button>

                            </div>

                            <div className="d-flex gap-2">

                                {/* Export dropdown */}
                                <div style={{ position: "relative" }}>
                                    <button
                                        className="btn btn-outline-success"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowExportMenu(prev => !prev);
                                        }}
                                    >
                                        Export ⬇
                                    </button>

                                    {showExportMenu && (
                                        <div
                                            onClick={(e) => e.stopPropagation()}
                                            style={{
                                                position: "absolute",
                                                right: 0,
                                                top: "100%",
                                                background: "#fff",
                                                border: "1px solid #ddd",
                                                borderRadius: "8px",
                                                boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                                                padding: "8px",
                                                zIndex: 999,
                                                minWidth: "100px"
                                            }}
                                        >
                                            <button
                                                className="dropdown-item"
                                                onClick={() => {
                                                    handleExport("pdf");
                                                    setShowExportMenu(false);
                                                }}
                                            >
                                                📄 PDF
                                            </button>

                                            <button
                                                className="dropdown-item"
                                                onClick={() => {
                                                    handleExport("xlsx");
                                                    setShowExportMenu(false);
                                                }}
                                            >
                                                📊 Excel
                                            </button>
                                        </div>
                                    )}
                                </div>


                                {/* Search */}
                                <input
                                    className="form-control"
                                    style={{ width: "220px" }}
                                    placeholder="Search employee..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />

                                {activeTab === "saved" && (
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => setShowAllocateModal(true)}
                                    >
                                        + Allocate
                                    </button>
                                )}

                            </div>



                        </div>

                    </div>



                    {/* Sticky Filters */}
                    <div
                        className="p-3 border-bottom bg-white"
                        style={{ position: "sticky", top: 0, zIndex: 5 }}
                    >
                        <div className="row g-3">

                            <div className="col-md-2">
                                <label className="form-label">Employee</label>
                                <select
                                    name="employeeId"
                                    value={filters.employeeId}
                                    onChange={handleFilterChange}
                                    className="form-select"
                                >
                                    <option value="">All Employees</option>
                                    {employees.map(e => (
                                        <option key={e.id} value={e.id}>
                                            {e.firstName} {e.lastName}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-2">
                                <label className="form-label">Month</label>
                                <input
                                    type="month"
                                    name="month"
                                    value={filters.month}
                                    onChange={handleFilterChange}
                                    className="form-control"
                                />
                            </div>

                            {(activeTab === "saved" || activeTab === "billing") && (
                                <div className="col-md-2">
                                    <label className="form-label">Project</label>
                                    <select
                                        name="projectId"
                                        value={filters.projectId}
                                        onChange={handleFilterChange}
                                        className="form-select"
                                    >
                                        <option value="">All Projects</option>
                                        {allProjects.map(p => (
                                            <option key={p.id} value={p.id}>
                                                {p.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}



                            {/* <div className="col-md-2">
                                <button className="btn btn-outline-dark w-100" onClick={resetFilters}>
                                    Reset
                                </button>
                            </div> */}

                        </div>
                    </div>

                    <div className="card-body p-0 d-flex flex-column" style={{ height: "calc(100vh - 200px)" }}>


                        {activeTab === "utilization" && (
                            loading ? (
                                <div className="text-center p-5">
                                    <div className="spinner-border text-primary"></div>
                                </div>
                            ) : (
                                <div style={{ height: "calc(100vh - 375px)", overflowY: "auto" }}>

                                    <table className="table table-bordered table-hover align-middle mb-0">
                                        <thead className="table-light" style={{
                                            position: "sticky",
                                            top: 0,
                                            zIndex: 10,
                                            background: "#f8f9fa"
                                        }}>
                                            <tr>
                                                <th>S.No</th>

                                                <th style={{ cursor: "pointer" }} onClick={() => requestSort("employeeCode")}>
                                                    Employee ID {sortConfig.key === "employeeCode" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                                </th>

                                                <th style={{ cursor: "pointer" }} onClick={() => requestSort("employeeName")}>
                                                    Name {sortConfig.key === "employeeName" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                                </th>

                                                <th style={{ cursor: "pointer" }} onClick={() => requestSort("designation")}>
                                                    Role {sortConfig.key === "designation" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                                </th>

                                                <th style={{ cursor: "pointer" }} onClick={() => requestSort("billableHours")}>
                                                    Billing {sortConfig.key === "billableHours" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                                </th>

                                                <th style={{ cursor: "pointer" }} onClick={() => requestSort("availableHours")}>
                                                    Available {sortConfig.key === "availableHours" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                                </th>

                                                <th
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => requestSort("allocatedHours")}
                                                >
                                                    Allocated Hrs {sortConfig.key === "allocatedHours" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                                </th>

                                                <th
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => requestSort("remainingHours")}
                                                >
                                                    Remaining Hrs {sortConfig.key === "remainingHours" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                                </th>



                                                <th style={{ cursor: "pointer" }} onClick={() => requestSort("overallUtilization")}>
                                                    Utilization {sortConfig.key === "overallUtilization" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                                </th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            {sortData(filteredData, sortConfig).map((row, idx) => {

                                                const allocated = getAllocatedHours(row.employeeId, row.availableHours);
                                                const remaining = getRemainingUtilizationHours(row.employeeId, row.availableHours);

                                                return (
                                                    <tr key={idx}>
                                                        <td>{idx + 1}</td>

                                                        <td>{row.employeeCode}</td>
                                                        <td>{row.employeeName}</td>
                                                        <td>{row.designation}</td>

                                                        <td>{Number(row.billableHours || 0).toFixed(2)}</td>
                                                        <td>{Number(row.availableHours || 0).toFixed(2)}</td>

                                                        <td className="fw-semibold text-primary">
                                                            {Number(allocated || 0).toFixed(2)}
                                                        </td>

                                                        <td className="fw-semibold text-success">
                                                            {Number(remaining || 0).toFixed(2)}
                                                        </td>

                                                        <td>
                                                            <strong>{Number(row.overallUtilization || 0).toFixed(2)}%</strong>
                                                            {renderProgress(row.overallUtilization)}
                                                        </td>
                                                    </tr>

                                                );
                                            })}

                                        </tbody>
                                    </table>
                                </div>
                            )
                        )}

                        {activeTab === "saved" && (
                            <div style={{ height: "calc(100vh - 375px)", overflowY: "auto" }}>

                                <table className="table table-bordered table-hover mb-0">
                                    <thead className="table-light" style={{
                                        position: "sticky",
                                        top: 0,
                                        zIndex: 10,
                                        background: "#f8f9fa"
                                    }}>
                                        <tr>
                                            <th style={{ cursor: "pointer" }} onClick={() => requestSavedSort("employeeName")}>
                                                Employee Name {savedSortConfig.key === "employeeName" ? (savedSortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>

                                            <th style={{ cursor: "pointer" }} onClick={() => requestSavedSort("projectName")}>
                                                Project {savedSortConfig.key === "projectName" ? (savedSortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>

                                            <th style={{ cursor: "pointer" }} onClick={() => requestSavedSort("allocationPercent")}>
                                                Allocation (%) {savedSortConfig.key === "allocationPercent" ? (savedSortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>

                                            <th style={{ cursor: "pointer" }} onClick={() => requestSavedSort("startDate")}>
                                                Start {savedSortConfig.key === "startDate" ? (savedSortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>

                                            <th style={{ cursor: "pointer" }} onClick={() => requestSavedSort("endDate")}>
                                                End {savedSortConfig.key === "endDate" ? (savedSortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>

                                            <th style={{ cursor: "pointer" }} onClick={() => requestSavedSort("monthlyHours")}>
                                                Monthly Allocated Hours {savedSortConfig.key === "monthlyHours" ? (savedSortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                            </th>

                                            <th className="text-center">Action</th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        {sortData(filteredSavedAllocations, savedSortConfig).map(a => (
                                            <tr key={a.id}>
                                                <td>{a.employeeName}</td>
                                                <td>{a.projectName}</td>
                                                <td>{a.allocationPercent}%</td>
                                                <td>{a.startDate}</td>
                                                <td>{a.endDate}</td>
                                                <td>{Number(a.monthlyHours || 0).toFixed(2)}</td>


                                                <td className="text-center d-flex justify-content-center gap-2">

                                                    <i
                                                        className="bi bi-files"
                                                        style={{ cursor: "pointer", fontSize: "18px", color: "#0d6efd", transition: "0.2s" }}
                                                        onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                                                        onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
                                                        title="Copy to next month"
                                                        onClick={() => handleCopyAllocation(a)}
                                                    ></i>


                                                    <i
                                                        className="bi bi-trash"
                                                        style={{ cursor: "pointer", fontSize: "18px", transition: "0.2s" }}
                                                        onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                                                        onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
                                                        title="Delete allocation"
                                                        onClick={() => {
                                                            setDeleteTarget(a);
                                                            setShowDeleteModal(true);
                                                        }}

                                                    ></i>

                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {activeTab === "billing" && (
                            billingLoading ? (
                                <div className="text-center p-5">
                                    <div className="spinner-border text-primary"></div>
                                </div>
                            ) : (
                                <div style={{ height: "calc(100vh - 375px)", overflowY: "auto" }}>


                                    <table className="table table-bordered table-hover mb-0">

                                        <thead className="table-light" style={{
                                            position: "sticky",
                                            top: 0,
                                            zIndex: 10,
                                            background: "#f8f9fa"
                                        }}>
                                            <tr>
                                                <th style={{ cursor: "pointer" }} onClick={() => requestBillingSort("projectName")}>
                                                    Project {billingSortConfig.key === "projectName" ? (billingSortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                                </th>

                                                <th style={{ cursor: "pointer" }} onClick={() => requestBillingSort("billing")}>
                                                    Billing Hours {billingSortConfig.key === "billing" ? (billingSortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                                </th>

                                                <th style={{ cursor: "pointer" }} onClick={() => requestBillingSort("allocated")}>
                                                    Allocated Hours {billingSortConfig.key === "allocated" ? (billingSortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                                </th>

                                                <th style={{ cursor: "pointer" }} onClick={() => requestBillingSort("utilization")}>
                                                    Utilization {billingSortConfig.key === "utilization" ? (billingSortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                                </th>
                                            </tr>

                                        </thead>

                                        <tbody>

                                            {sortBillingData(filteredBillingData).map(project => (


                                                <React.Fragment key={project.projectName}>

                                                    <tr
                                                        style={{ cursor: "pointer", fontWeight: "600" }}
                                                        onClick={() => toggleProject(project.projectName)}
                                                    >
                                                        <td>
                                                            <i className={`bi ${expandedProjects[project.projectName] ? "bi-chevron-down" : "bi-chevron-right"} me-2`} />
                                                            {project.projectName}
                                                        </td>

                                                        <td>{Number(project.totalBillingHours || 0).toFixed(2)}</td>
                                                        <td>{Number(project.totalAllocatedHours || 0).toFixed(2)}</td>
                                                        <td>{Number(project.avgUtilization || 0).toFixed(2)}%</td>
                                                    </tr>

                                                    {expandedProjects[project.projectName] &&
                                                        project.employees.map((emp, i) => (
                                                            <tr key={i} className="table-light">
                                                                <td style={{ paddingLeft: "40px" }}>{emp.employeeName}</td>
                                                                <td>{Number(emp.billingHours || 0).toFixed(2)}</td>
                                                                <td>{Number(emp.allocatedHours || 0).toFixed(2)}</td>
                                                                <td>{Number(emp.utilization || 0).toFixed(2)}%</td>
                                                            </tr>
                                                        ))
                                                    }

                                                </React.Fragment>

                                            ))}

                                        </tbody>

                                    </table>

                                </div>
                            )
                        )}




                    </div>


                </div>

            </div>

            {showAllocateModal && (
                <>
                    <div className="modal fade show d-block" style={{ paddingTop: "120px" }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">

                                <div className="modal-header border-bottom" >
                                    <h5 className="fw-semibold">Allocate Monthly Hours</h5>
                                    <button className="btn-close" onClick={() => {
                                        resetAllocateForm();
                                        setShowAllocateModal(false);
                                    }} />
                                </div>

                                <div className="modal-body">

                                    <div className="container-fluid">

                                        {/* Row 1 */}
                                        <div className="row g-3">

                                            <div className="col-md-6">
                                                <label className="form-label">Employee</label>
                                                <select
                                                    name="employeeId"
                                                    className="form-select"
                                                    value={allocateForm.employeeId}
                                                    onChange={handleAllocateChange}
                                                >
                                                    <option value="">Select</option>
                                                    {employees.map(e => (
                                                        <option key={e.id} value={e.id}>
                                                            {e.firstName} {e.lastName}
                                                        </option>
                                                    ))}
                                                </select>
                                                <small className="text-muted">
                                                    {allocateForm.employeeId && allocateForm.startDate ? (
                                                        <span>
                                                            Remaining: <strong>
                                                                {getRemainingPercent(
                                                                    allocateForm.employeeId,
                                                                    allocateForm.startDate
                                                                ).toFixed(1)}%
                                                            </strong>
                                                        </span>
                                                    ) : (
                                                        <span className="text-secondary fst-italic">
                                                            Remaining will appear after selection
                                                        </span>
                                                    )}
                                                </small>

                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Project</label>
                                                <select
                                                    name="projectId"
                                                    className="form-select"
                                                    value={allocateForm.projectId}
                                                    onChange={handleAllocateChange}
                                                >
                                                    <option value="">Select</option>
                                                    {projects.map(p => (
                                                        <option key={p.id} value={p.id}>{p.name}</option>
                                                    ))}
                                                </select>

                                            </div>

                                            {/* Row 2 */}

                                            <div className="col-md-6">
                                                <label className="form-label">Start Date</label>
                                                <input
                                                    type="date"
                                                    name="startDate"
                                                    className="form-control"
                                                    value={allocateForm.startDate}
                                                    onChange={handleAllocateChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">End Date</label>
                                                <input
                                                    type="date"
                                                    name="endDate"
                                                    className="form-control"
                                                    value={allocateForm.endDate}
                                                    onChange={handleAllocateChange}
                                                />
                                            </div>


                                            {/* Row 3 */}
                                            <div className="col-md-6">
                                                <label className="form-label">Allocation %</label>
                                                <input
                                                    type="number"
                                                    name="percent"
                                                    className="form-control"
                                                    value={allocateForm.percent}
                                                    onChange={handleAllocateChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Monthly Allocated Hours</label>
                                                <input
                                                    className="form-control"
                                                    value={allocateForm.monthlyHours}
                                                    readOnly
                                                />
                                            </div>




                                        </div>

                                    </div>

                                </div>


                                <div className="modal-footer">
                                    <button className="btn btn-primary px-4" onClick={saveAllocation}>
                                        Save
                                    </button>

                                    <button
                                        className="btn btn-secondary border"
                                        onClick={() => {
                                            resetAllocateForm();
                                            setShowAllocateModal(false);
                                        }}
                                    >
                                        Cancel
                                    </button>


                                </div>


                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade show"></div>
                </>
            )}


            {showDeleteModal && deleteTarget && (
                <>
                    <div className="modal fade show d-block" style={{ paddingTop: "150px" }}>
                        <div className="modal-dialog">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="fw-semibold text-danger">
                                        Confirm Delete
                                    </h5>
                                    <button
                                        className="btn-close"
                                        onClick={() => setShowDeleteModal(false)}
                                    />
                                </div>

                                <div className="modal-body">

                                    <p className="mb-2">
                                        Are you sure you want to delete this allocation?
                                    </p>

                                    <div className="border rounded p-3 bg-light small">

                                        <div><strong>Employee:</strong> {deleteTarget.employeeName}</div>
                                        <div><strong>Project:</strong> {deleteTarget.projectName}</div>
                                        <div><strong>Allocation:</strong> {deleteTarget.allocationPercent}%</div>
                                        <div><strong>Month:</strong> {deleteTarget.startDate?.slice(0, 7)}</div>

                                    </div>

                                    <p className="text-danger mt-3 mb-0">
                                        This action cannot be undone.
                                    </p>

                                </div>

                                <div className="modal-footer">
                                    <button
                                        className="btn btn-danger"
                                        onClick={confirmDeleteAllocation}
                                    >
                                        Delete
                                    </button>

                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setShowDeleteModal(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade show"></div>
                </>
            )}


        </div>
    );
};

export default AllocationPage;
